// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListNavigation-root-qaX_9 {
  margin: 0;
}

.ListNavigation-exitText-f0EtK {
  color: var(--btn-primary-bg) !important;
}

@media screen and (max-width: 743px) {
  .ListNavigation-hideSm-L6Ijb {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/List/ListNavigation.css"],"names":[],"mappings":"AAAA;EACE,SAAS;AACX;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".root {\n  margin: 0;\n}\n\n.exitText {\n  color: var(--btn-primary-bg) !important;\n}\n\n@media screen and (max-width: 743px) {\n  .hideSm {\n    display: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ListNavigation-root-qaX_9`,
	"exitText": `ListNavigation-exitText-f0EtK`,
	"hideSm": `ListNavigation-hideSm-L6Ijb`
};
module.exports = ___CSS_LOADER_EXPORT___;
